import { render } from "./MediaPicker.vue?vue&type=template&id=fa6053a0"
import script from "./MediaPicker.vue?vue&type=script&lang=js"
export * from "./MediaPicker.vue?vue&type=script&lang=js"

import "./MediaPicker.vue?vue&type=style&index=0&id=fa6053a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__